import type { INewMarkCfg, IRecord } from '@gp/types/global';

export const PIPELINE_PROJECT_DETAIL_TABS_NEW_ICON_CFG_MAPPING: IRecord<INewMarkCfg> = {
  gameDetail: {
    showNew: false,
    newMarkType: 0,
  },
  milestone: {
    showNew: false,
    newMarkType: 0,
  },
  projectUpdate: {
    showNew: false,
    newMarkType: 0,
  },
  finance: {
    showNew: false,
    newMarkType: 0,
  },
  stakeholder: {
    showNew: false,
    newMarkType: 0,
  },
  technical: {
    showNew: false,
    newMarkType: 0,
  },
};
